import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import api from "../lib/api";
import RatingReply from "./RatingReply";
import RatingDetails from "./RatingDetails";
import { useAuth } from "../context/AuthContext";

export default function ReceivedRatings({ avg, count }) {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const load = () => api.get("/me/ratings").then(({ data }) => setItems(data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="received-ratings-panel">
      <div className="ga-card p-5 flex flex-wrap items-center gap-4 mb-5">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Rating medio</div>
          <div className="font-display text-4xl font-extrabold text-slate-900">{(avg || 0).toFixed(1)}<span className="text-base text-slate-500 font-normal"> / 5</span></div>
        </div>
        <div className="flex items-center gap-0.5">
          {[1,2,3,4,5].map(n => <Star key={n} className={`w-6 h-6 ${n <= Math.round(avg || 0) ? "fill-amber-500 text-amber-500" : "text-slate-300"}`} />)}
        </div>
        <div className="text-sm text-slate-600">{count || 0} recension{count === 1 ? "e" : "i"} ricevut{count === 1 ? "a" : "e"}</div>
      </div>
      {items === null && <div className="text-sm text-slate-500 py-6">Caricamento...</div>}
      {items && items.length === 0 && <div className="ga-card p-8 text-center text-sm text-slate-500">Ancora nessuna recensione ricevuta.</div>}
      <div className="space-y-3">
        {(items || []).map(r => (
          <div to={`/ordine/${r.order_id}`} key={r.id} className="ga-card p-5 block" data-testid={`received-review-${r.id}`}>
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <Link to={`/ordine/${r.order_id}`} className="font-semibold text-slate-900 truncate hover:underline block">{r.rater_name}</Link>
                <div className="text-xs font-mono text-slate-500 mt-0.5 truncate">{r.order_title} · {new Date(r.created_at).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" })}</div>
              </div>
              <div className="flex items-center gap-0.5 shrink-0">
                {[1,2,3,4,5].map(n => <Star key={n} className={`w-4 h-4 ${n <= Math.round(r.stars) ? "fill-amber-500 text-amber-500" : "text-slate-300"}`} />)}
              </div>
            </div>
            {r.review && <p className="mt-2 text-sm text-slate-700">{r.review}</p>}
            <RatingDetails details={r.details} />
            <RatingReply rating={r} supplierName={user?.business_name || user?.name} canReply={user?.role === "supplier"} onReplied={load} />
          </div>
        ))}
      </div>
    </div>
  );
}
